import moment, {Moment} from 'moment';
import CallDetails from 'records/CallDetails';
import {List} from 'immutable';
import {Data, RecordProps} from '@store/@types/util';
import {FileUploadId} from 'records/CoachingReviewFileUpload';

export type InboxItemId = unknown;
type TagId = unknown;
type FolderId = number;
interface InboxItemInterface {
  id: InboxItemId;
  context: unknown;
  created?: Moment;
  fileUploadId: FileUploadId;
  pinned: boolean;
  tag: unknown;
  tagId: TagId;
  viewedDate?: Moment;
  // TODO this column should be removed, it doesn't actually exist
  hasBeenShared?: boolean;
  folderId: FolderId;
  call: CallDetails;
  linkTitle?: string;
  isGrouped?: boolean;
  groupedItems?: List<InboxItem>;
  useNestedDescriptions?: boolean;
}

export default class InboxItem extends Data<InboxItemInterface>({
  id: undefined,
  context: undefined,
  created: undefined,
  fileUploadId: undefined,
  pinned: undefined,
  tag: undefined,
  tagId: undefined,
  viewedDate: undefined,
  // TODO this column should be removed, it doesn't actually exist
  hasBeenShared: undefined,
  folderId: undefined,
  call: undefined,
  linkTitle: undefined,
  isGrouped: undefined,
  groupedItems: undefined,
  useNestedDescriptions: undefined,
}) {
  constructor(props: RecordProps<InboxItemInterface> = {}) {
    super({
      ...props,
      created: props.created ? moment(props.created) : undefined,
      viewedDate: props.viewedDate ? moment(props.viewedDate) : undefined,
      call: props.call ? new CallDetails(props.call) : props.call,
      groupedItems: props.groupedItems
        ? List(props.groupedItems.map(gi => new InboxItem({...gi, isGrouped: false})))
        : undefined,
    });
  }

  getIds() {
    return this.isGrouped ? this.groupedItems!.map(it => it.id) : List([this.id]);
  }
}
